<!-- 项目文件 -->
<template>
    <div class="posre">
        <Header :Logo="logo" ref="mychild" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p bgf6">
            <div class="w1200 mauto bgf6">
                <div class=" pt30 pb20 " id="coop1">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                热门解决方案
                            </span>
                        </p>
                    </div>

                    
                    <div class="overflow   ml-10 textc">
                        <div class="bg273 disinblock w18p mt15 box ml10 mr10 vertop posre pl15 pr15 overflow">
                            <div class=" pt15 pb12 minh120 cursor">
                                <div class="textl alit">
                                    <img class="h44 w44" src="../../public/img/img282.png" alt="">
                                    <span class="disinblock pl10 fs18 fbold cfff">驾培系统</span>
                                </div>
                                <div class="textl fs12 cfff pt14 lh20 over_3">
                                    降低驾校经营成本，增强管理效率，优秀的交互体验，提高服务品质，提升品牌质量
                                </div>
                            </div>
                            <div  class="cardbtn cursor bradius8">
                                <router-link to="DriveSystem">
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">驾培系统></p>
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">了解更多></p>
                                </router-link>
                            </div>
                        </div>


                        <div class="bg274 disinblock  w18p mt15 box ml10 mr10  vertop pl15 pr15 posre overflow">
                            <div class="pt15 pb10 minh120 cursor fs0">
                                <div class="textl alit">
                                    <img class="h44 w44" src="../../public/img/img278.png" alt="">
                                    <span class="disinblock pl10 fs18 fbold cfff">小程序营销系统</span>
                                </div>
                                <div class="textl fs12 cfff pt14 lh20">
                                    打破营销获客传播壁垒，精准获客， 并具有出色的用户体验。
                                </div>
                            </div>
                            <div class="cardbtn cursor bradius8 fs0">
                                <router-link to="SmallMark">
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">小程序营销系统></p>
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">了解更多></p>
                                </router-link>
                            </div>
                        </div>

                        <div class="bg275 disinblock  w18p mt15 box ml10 mr10  pl15 pr15 vertop posre overflow">
                            <div class="  pt15 pb12 minh120">
                                <div class="textl alit">
                                    <img class="h44 w44" src="../../public/img/img279.png" alt="">
                                    <span class="disinblock pl10 fs18 fbold cfff">增值业务</span>
                                </div>
                                <div class="textl fs12 cfff pt14 lh20">
                                    触达驾培末端细节，挖掘经营点位， 解决营销难题。
                                </div>
                            </div>

                            <div class="cardbtn cursor bradius8 fs0">
                                <router-link to="addvalue">
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">增值业务></p>
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">了解更多></p>
                                </router-link>
                            </div>
                        </div>
                        <div class="bg276 disinblock  w18p mt15 box ml10 mr10 posre  pl15 pr15  vertop overflow">
                            <div class=" pt15 pb12 minh120">
                                <div class="textl alit">
                                    <img class="h44 w44" src="../../public/img/img280.png" alt="">
                                    <span class="disinblock pl10 fs18 fbold cfff">流量经营</span>
                                </div>
                                <div class="textl fs12 cfff pt14 lh20">
                                    共建本地服务流量池，打通消费流量 闭环，解决经营流量需求。
                                </div>
                            </div>
                            <div class="cardbtn cursor bradius8 fs0">
                                <router-link to="Flow">
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">增值业务></p>
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">了解更多></p>
                                </router-link>
                            </div>
                        </div>
                        <div class="bg277 disinblock  w18p mt15 box ml10 mr10 vertop posre pl15 pr15 overflow">
                            <div class="pt15 pb12 minh120">
                                <div class="textl alit">
                                    <img class="h44 w44" src="../../public/img/img281.png" alt="">
                                    <span class="disinblock pl10 fs18 fbold cfff">业务合作</span>
                                </div>
                                <div class="textl fs12 cfff pt14 lh20">
                                    支持平台、商户流量合作
                                </div>
                            </div>
                            <div class="cardbtn cursor bradius8 fs0">
                                <router-link to="Businesscoop">
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">申请合作></p>
                                    <p class="fs16 cfff  h50p alit flexc border2 ml16 mr16">了解更多></p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="  pb40 " style="background: #fafcff;">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                特色功能
                            </span>
                        </p>
                    </div>
                    <div class="textc disflex">
                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w42 h42" src="../../public/img/img283.png">
                                <span class="disblock fs18 c333 pt30">考务系统</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">快速掌握学员考试动态</p>
                                <p class="cb2b2 fs13 pb5 pt5">合理安排教学计划</p>
                                <p class="cb2b2 fs13">精准核算</p>
                            </div>
                        </div>
                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w44 h44" src="../../public/img/img284.png">
                                <span class="disblock fs18 c333 pt30">培训系统</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">为驾校提供</p>
                                <p class="cb2b2 fs13 pb5 pt5">个性化定制驾培服务</p>
                                <p class="cb2b2 fs13">降低驾校经营成本</p>
                            </div>
                        </div>

                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w44 h44" src="../../public/img/img285.png">
                                <span class="disblock fs18 c333 pt30">小程序</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">快速精准拓客</p>
                                <p class="cb2b2 fs13 pb5 pt5">打破营销</p>
                                <p class="cb2b2 fs13">获客壁垒</p>
                            </div>
                        </div>
                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w34 h45" src="../../public/img/img286.png">
                                <span class="disblock fs18 c333 pt30">驾考无忧</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">解决驾校招生营销</p>
                                <p class="cb2b2 fs13 pb5 pt5">价格战难题，用服务获客</p>
                                <p class="cb2b2 fs13">打消学员驾考顾虑</p>
                            </div>
                        </div>
                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w47 h43" src="../../public/img/img287.png">
                                <span class="disblock fs18 c333 pt30">精品题库</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">降低学员背题难度</p>
                                <p class="cb2b2 fs13 pb5 pt5">满足学员需求</p>
                                <p class="cb2b2 fs13">实现销售转化</p>
                            </div>
                        </div>
                        <div class="w14p disinblock ml10 mr10 bgfff bradius8 pl15 pr15 pt40 pb30 cursor">
                            <p>
                                <img class="w52 h50" src="../../public/img/img288.png">
                                <span class="disblock fs18 c333 pt30">学车线索</span>
                            </p>
                            <div class=" ">
                                <p class="cb2b2 fs13 ">满足驾校</p>
                                <p class="cb2b2 fs13 pb5 pt5">招生需求</p>
                                <p class="cb2b2 fs13">提供生源线索</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="   pb40 posre zindex1">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                合作商家
                            </span>
                        </p>
                    </div>
                    <div class="overflow  ">
                        <ul class="w100p disblock pb20">
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10  pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img330.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">大学生的优质资讯和服务运营平台</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">今日校园：是以手机 App 为载体，学生成长体系为模型，聚合了校内及校外互联网优质的
                                    内容和应用，为大学生提供学习、生活、就业等全方面优质服务的移动互联网平台</P>
                                </div>
                            </li>

                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10  pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img331.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">专业大学生生活服务平台</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">猴惠玩儿：专业大学生生活服务平台，为在校大学生在线提供洗衣、水房等在校生活服务平台</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10  pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img332.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">广电旗下,覆盖20多的大中城市</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">广电网络：广电旗下，覆盖20多的大中城市，为市民提供本地生活、娱乐、资讯等综合服务平台</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img333.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">互联网+社区服务提供商</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">菜鸟驿站：阿里巴巴旗下，社会化物流协同、以数据为驱动力的平台，互联网+社区服务提供商</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img334.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">中国农业银行电子服务渠道</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">中国农业银行：中国农业银行电子服务渠道（中国农业银行APP、微信公众号），为用户提供银行金融服务与本地生活服务平台</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img335.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">上汽集团旗下汽车市场服务综合平台</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">上汽·东华：隶属于上汽集团，为用户提供本地化服务，汽车服务，包含上汽9大品牌的汽车市场服务与本地用户汽车驾驶培训服务的综合平台</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img336.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">上汽集团-全球车享品牌</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">车享家：上汽集团-全球车享品牌，为用户提供本地化的汽车保养、维修、洗车等综合服务平台</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img337.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">国内综合性保险(金融)公司</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">人保：国内综合性保险（金融）公司，世界五百强之一，也是世界上最大的保险公司之一，属中央金融企业</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img338.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">中国大陆第二大财产保险公司</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">太平洋：中国大陆第二大财产保险公司，为用户提供多元化保险服务</P>
                                </div>
                            </li>
                            <li class="w18p mt15 disinblock bradius8 overflow posre box-shadow22 ml10 mr10   pb20 textc posre vertop  bgfff">
                                <div class=" minh220 bradius8">
                                    <img class="w94 h150 posre " src="../../public/img/img339.png">
                                    <p class="fs14 textc w100p  c999  posab bottom10 left0">中国第一家股份制保险企业</p>
                                </div>
                                <div class="cardbtn cardbtn2 cursor bradius8 bradius8 alit">
                                    <P class="pl15 pr15 lh22 cfff fs12">平安：中国第一家股份制保险企业，是集金融保险、银行、投资等金融业务为一体的整合、紧密、多元的综合金融服务集团。</P>
                                </div>
                            </li>

                           




                            
                        </ul>
                    </div>
                    <div class="mt20 mb20 textc">
                        <span @click="openChild()" class="cfff cursor bg1f8 bradius5 fs18 disinblock fbold h50 lh50 w240">合作申请</span>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img87.png'),
                titleList: 3,
                link: 1,
                logo: 'coop',
                color: 2,
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            openChild() {
                this.$refs.mychild.foo();
            }
        },

        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
    
    .bg119 {
        background-image: url('../../public/img/img119.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg273 {
        background-image: url('../../public/img/img273.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg274 {
        background-image: url('../../public/img/img274.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg275 {
        background-image: url('../../public/img/img275.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg276 {
        background-image: url('../../public/img/img276.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg277 {
        background-image: url('../../public/img/img277.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .cardbtn {
        opacity: 0.85;
        background: #4B87FF;
        position: absolute;
        bottom: -148px;
        width: 100%;
        left: 0;
        height: 100%;
        transition: bottom 0.4s;
        overflow: hidden;
    }
    
    .cardbtn2 {
        bottom: -242px;
    }
    
    .w18p:hover div {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .bg273:hover .cardbtn {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .bg274:hover .cardbtn {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .bg275:hover .cardbtn {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .bg276:hover .cardbtn {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .bg277:hover .cardbtn {
        bottom: 0;
        transition: bottom 0.4s;
    }
    
    .w14p:hover .c333 {
        color: #1f82f6;
    }
    
    .w14p:hover .cb2b2 {
        color: #333;
    }
    
    .w14p:hover {
        background: #FFFFFF;
        box-shadow: 0 3px 17px 0 #E2F3FF;
        border-radius: 2px;
        opacity: 1.0;
    }
</style>